<script setup>
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
</script>

<template>
  <!-- custom (redesign Modeloja · F7): contrato de largura ÚNICO. O wrapper PREENCHE o
       viewport (flex-1 min-w-0) e aplica o cap padrão de DADOS/LISTA .mj-page (≤1480, gutter
       responsivo) — vale p/ a maioria das telas de settings (listas/tabelas) e serve de
       rede de segurança (nenhuma rota filha estica full-width mesmo se não declarar largura).
       Os FORMS de leitura (Account, Profile, Security, assignmentPolicy, etc.) se constringem
       a .mj-reading (≤768) NO PRÓPRIO root — como .mj-page já dá o gutter, o form usa
       max-w interno centralizado (sem padding duplo). Antes: max-w-5xl (1024) fixo p/ tudo. -->
  <div
    class="flex flex-col flex-1 min-w-0 w-full h-full m-0 overflow-auto bg-n-surface-1"
  >
    <div class="mj-page">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
